module.exports = __webpack_public_path__ + "img/139.6fdd7564.jpg";